'use client';

// "Compare saved" on the saved-listings page (owner's approval, 2026-09-24).
// Zillow compares from the saved homes; the cards stay simple (listing browse
// plan), so one button above the list puts the latest saved listings - four
// at most - into the comparison and opens it.

import React from 'react';
import { useRouter } from 'next/navigation';
import { Scale } from 'lucide-react';
import { MAX_COMPARE, setCompareIds, useFavoriteIds } from '@/lib/local-lists';
import { comparePath } from '@/lib/localized-paths';

export default function CompareSavedButton({ lang }: { lang: string }) {
  const router = useRouter();
  const saved = useFavoriteIds();
  const isFr = lang === 'fr';
  if (saved.length < 2) return null;

  // The newest are last in the list.
  const pick = saved.slice(-MAX_COMPARE);
  const label =
    saved.length > MAX_COMPARE
      ? isFr ? `Comparer les ${MAX_COMPARE} dernières` : `Compare the latest ${MAX_COMPARE}`
      : isFr ? `Comparer les ${saved.length} annonces` : `Compare all ${saved.length}`;

  return (
    <button
      type="button"
      onClick={() => {
        setCompareIds(pick);
        router.push(comparePath(lang, pick));
      }}
      className="inline-flex items-center gap-2 h-10 px-4 rounded-full bg-champagne hover:bg-champagne/85 text-black text-sm font-bold transition-colors cursor-pointer"
    >
      <Scale className="w-4 h-4" aria-hidden="true" />
      {label}
    </button>
  );
}
